module.exports = __webpack_public_path__ + "img/img4.fw.b4d95d27.png";